import { httpClient, handleErrorResp, getOS, getBrowser, getUserAgent, getIpAddress, getToken } from '../UtilService';
import { ILogin, ILoginWithMSOffice, IStandardAPIResponse, IUpdatePassword } from '../../vm';

export async function loginToApp(
  cred: ILogin
): Promise<IStandardAPIResponse<any>> {
  try {
    // Collect session metadata
    const os = getOS();
    const browser = getBrowser();
    const userAgent = getUserAgent();

    let res = await httpClient<any>(
      `auth-web-login`,
      'POST',
      cred,
      false,
      "application/json; charset=utf-8",
      "", // No token needed for login
      true, // skipTokenRefresh = true for login endpoints
      {
        'X-Client-OS': os,
        'X-Client-Browser': browser,
        'User-Agent': userAgent
      }
    );
    return res;
  } catch (err) {
    return handleErrorResp(err);
  }
}

export async function loginToAppWithMSOffice(
  cred: ILoginWithMSOffice
): Promise<IStandardAPIResponse<any>> {
  try {
    let res = await httpClient<any>(
      `auth-web-login/ms-office`,
      'POST',
      cred,
      false,
      "application/json; charset=utf-8",
      "", // No token needed for login
      true // skipTokenRefresh = true for login endpoints
    );
    return res;
  } catch (err) {
    return handleErrorResp(err);
  }
}

export async function updateAdminPassword(
  cred: IUpdatePassword
): Promise<IStandardAPIResponse<any>> {
  try {
    let res = await httpClient<any>(
      `datacenter-admins/update-password`,
      'POST',
      cred
    );
    return res;
  } catch (err) {
    return handleErrorResp(err);
  }
}
export async function updateTeamRolePassword(
  cred: IUpdatePassword
): Promise<IStandardAPIResponse<any>> {
  try {
    let res = await httpClient<any>(`teams/update-password`, 'POST', cred);
    return res;
  } catch (err) {
    return handleErrorResp(err);
  }
}
export async function lastPasswordUpdatedTime(): Promise<
  IStandardAPIResponse<{ date?: Date }>
> {
  try {
    let res = await httpClient<{ date?: Date }>(
      `last-password-updated-time`,
      'GET'
    );
    return res;
  } catch (err) {
    return handleErrorResp(err);
  }
}
export async function changeExpiredPasswordForAdmin(
  password: string,
  token?: string
): Promise<IStandardAPIResponse<{ date?: Date }>> {
  try {
    let res = await httpClient<{ date?: Date }>(
      `datacenter-admins/update-expired-password`,
      'PATCH',
      { password },
      false,
      undefined,
      token
    );
    return res;
  } catch (err) {
    return handleErrorResp(err);
  }
}
export async function changeExpiredPasswordForTeam(
  password: string,
  token?: string
): Promise<IStandardAPIResponse<{ date?: Date }>> {
  try {
    let res = await httpClient<{ date?: Date }>(
      `teams/update-expired-password`,
      'PATCH',
      { password },
      false,
      undefined,
      token
    );
    return res;
  } catch (err) {
    return handleErrorResp(err);
  }
}
export async function logoutUser() {
  try {
    let res = await httpClient<any>(
      `logout`,
      'POST',
      {},
      false,
      "application/json; charset=utf-8",
      getToken(),
      true // skipTokenRefresh = true for login endpoints
    );
    return res;
  } catch (err) {
    return handleErrorResp(err);
  }
}
